ClickableMap = (function () {
    var areaClicked = function (activeArea, href) {
        region = $(activeArea).attr("redirect-url");
        if (typeof(region) === "undefined") {
            region = $(activeArea).parent().find("tspan").text();
        }
        href = href.replace("{area}", region.replace(/\s|\&\s/g, "-"));
       
        window.location.href = href;

    };
    var areaOnMouseOver = function (activeArea) {
        var activeText = $(activeArea).parent().find("text");
        var siblings = $(activeArea).siblings("path, polyline");
        $("path, polyline").not(activeArea).not(siblings).css({ opacity: "0.1" });
        $("text").not(activeText).css({ opacity: "0.1" });
    };
    var areaOnMouseLeave = function () {
        $("path, polyline").css({ opacity: "1.0" });
        $("text").css({ opacity: "1.0" });
    };
    return {
        mapAreaClicked: function(activeArea, href) {
            areaClicked(activeArea, href);
        },

        mapAreaMouseOver: function (activeArea) {

            areaOnMouseOver(activeArea);
        },
        mapAreaMouseLeave: function () {

            areaOnMouseLeave();
        }
          
        }
})();